<app-header></app-header>

<div class="container h-100 overflow-auto">
    <div class="container plns">
        <h2>About Us</h2>
    </div>
    <div class="p-5">
        <p>Schoold™ is an edtech company founded to democratize the scholarship application process by helping
            first-generation Black students transition from debt and doubt to scholarship and success in education.</p>
        <p>We connect college students to scholarships at scale to help fund their education. Our goal is to help more
            students graduate school debt-free and build the lives of their dreams into reality.</p>
        <p>With our three tier subscription plans, scholars can choose how accelerated they want to apply to
            scholarships.</p>
        <p>Schoold™ is transforming the scholarship application process through our uniformed scholarship application
            form so that students apply at scale granting them a more equitable access to the higher education they
            deserve.</p>

    </div>

</div>